export default {
  message: {
    Tour: {
      continue: "Davom etish",
      back: "Orqaga",
      finish: "Tugatish"
    },
    Login: {
      title: "Ota-onalar uchun kirish",
      sign_in: "Kirish",
      login_fail:
        "Autentifikatsiya muvaffaqiyatsiz. Qaytadan urinib ko'ring yoki maktab bilan bog'laning.",
      forgot_password: "Parolni unutdingizmi",
      create_account: "Hisob yaratish",
      password: "Parol",
      confirm_password: "Parolni tasdiqlang",
      password_reminder: "Parol eslatmasi",
      enter_email: "Elektron pochta manzilingizni kiriting",
      validation_error: "Tekshiruv xato xabari",
      password_reminder_error_no_user_register:
        "Kiritilgan foydalanuvchi topilmadi. Qaytadan urinib ko'ring yoki yangi hisob yarating.",
      password_reminder_error_no_user: "Kiritilgan foydalanuvchi topilmadi.",
      password_reminder_sent: "Qo'shimcha ko'rsatmalar bilan xat {email} manziliga yuborildi.",
      password_reminder_sent_message:
        "Xat bir necha daqiqa ichida yetib kelishi mumkin. Inboxda ko'rmasangiz, spam papkasini tekshiring.",
      password_trouble_email: "Muammo davom etsa, {email} bilan bog'laning.",
      password_trouble_school:
        "Muammo davom etsa, maktab bilan bog'laning.",
      return_to_sign_in: "Kirish sahifasiga qaytish",
      create_my_account: "Hisobimni yaratish",
      or_sign_in_with: "YOKI BILAN KIRISH",
      password_reset: "Hisobingiz uchun yangi parol tanlang.",
      password_reset_warning:
        "Parol o'zgartirishni so'ramagan bo'lsangiz, darhol maktab ma'muriga murojaat qiling.",
      password_update: "Yangi parol tanlang",
      password_update_confirm: "Yangi parolni tasdiqlang",
      password_update_success: "Yangi parolingiz saqlandi."
    },
    AccountSettings: {
      title: "Hisob sozlamalari",
      first_name: "Ism",
      last_name: "Familiya",
      email: "Elektron pochta",
      username: "Foydalanuvchi nomi",
      password: "Parol",
      students: "O'quvchilar",
      teachers: "O'qituvchilar",
      external_id: "Tashqi ID",
      phone: "Telefon raqami",
      phone_required: "Telefon raqami majburiy",
      edit: "Tahrirlash",
      remove: "O'chirish",
      add: "Qo'shish",
      remove_message: "Bu o'quvchini o'chirmoqchimisiz?",
      yes: "Ha",
      no: "Yo'q",
      add_student: "O'quvchi qo'shish",
      close: "Yopish",
      save: "O'zgarishlarni saqlash",
      cancel: "Bekor qilish",
      student_alert_message: "Kamida bitta o'quvchi kiriting.",
      logout: "Chiqish"
    },
    LeadStatus: {
      title: "Update Lead Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      reject: "Reject",
      updatedSuccess: "Lead status updated successfully",
      updateError: "Failed to update lead status",
      convertedNote: "This marks the lead as a customer. If a school exists, it may be set to active.",
      suppressedNote: "This suppresses the lead. You can restore it later from Suppressed.",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    WelcomeEmail: {
      title: "Send welcome email?",
      schoolLabel: "School",
      districtLabel: "District",
      contactLabel: "Contact",
      emailLabel: "Email",
      subdomainLabel: "Subdomain",
      usernameLabel: "Username",
      body: "PTC Wizard will email this account's admin-site credentials and documentation links.",
      confirm: "Send email",
      cancel: "Cancel",
      success: "Welcome email sent",
      error: "Failed to send welcome email",
      tooltip: "Send welcome email"
    },
    Navbar: {
      my_meetings: "Mening uchrashuvlarim",
      language: "O'zbek",
      help: "Yordam",
      account_settings: "Hisob sozlamalari",
      user_management: "User Management",
      logout: "Chiqish"
    },
    SubNavbar: {
      meeting: "Uchrashuv",
      event: "Tadbir",
      print: "Chop etish",
      email: "Elektron pochta",
      export: "Eksport"
    },
    ConferenceCard: {
      add_edit_meetings: "Uchrashuv qo'shish/tahrirlash",
      opening: "Ochiq",
      closed: "Yopiq"
    },
    Agenda: {
      full_agenda: "To'liq kun tartibi",
      empty_state_title: "Siz uchun hech qanday konferensiya topilmadi.",
      empty_state_message: "Savollar bo'lsa, maktab vakili bilan bog'laning.",
      confirmation_modal_title: "Kun tartibi tasdiqlandi",
      confirmation_modal_message:
        "Kun tartibingiz muvaffaqiyatli tasdiqlandi va sizga elektron pochta orqali yuborildi.",
      complete_button: "Tugatildi!"
    },
    AgendaCard: {
      room: "Xona mavjud emas",
      room_with_value: "Xona: {room}",
      virtual_meeting: "Virtual uchrashuv",
      all_conferences: "Barcha konferensiyalar",
      conference: "Konferensiya",
      student: "O'quvchi",
      meeting_with: "Uchrashuv",
      date_time: "Sana/vaqt",
      meeting_type: "Uchrashuv turi",
      location: "Manzil",
      comment: "Izoh",
      action: "Harakat",
      delete: "O'chirish",
      add_comment: "Izoh qo'shish",
      join: "Uchrashuvga qo'shilish",
      choose_meeting_type: "Uchrashuv turini tanlang",
      in_person: "Shaxsan",
      phone: "Telefon",
      callback: "Qayta qo'ng'iroq",
      virtual: "Virtual",
      hybrid: "Gibrid",
      unavailable: "Mavjud emas",
      tooltip_translator:
        "Tarjimon xizmati kafolatlanmaydi, lekin maktab mavjudligini ta'minlashga harakat qiladi.",
      translator_requested: "Tarjimon so'ralgan",
      clear_translator: "Tarjimon so'rovini tozalash",
      need_translator: "Tarjimon kerakmi?",
      choose_language: "Tilni tanlang"
    },
    ScheduleMatrix: {
      no_teachers_title: "O'qituvchilar yoki jamoalar tanlanmagan.",
      no_teachers_message: "Uchrashuv vaqtlarini ko'rish uchun o'qituvchini tanlang.",
      choose_teachers_button: "Mavjud o'qituvchilarni ko'rish",
      choose_student: "Qaysi o'quvchi uchun?",
      cancel: "Bekor qilish"
    },
    Matrix: {
      teachers: "O'qituvchilar",
      agenda: "Ko'rib chiqish va davom etish"
    },
    DrawerTeachers: {
      teachers: "O'qituvchilar",
      name: "Ism",
      description: "Tavsif",
      student: "O'quvchi",
      teacher_team: "O'qituvchi/jamoasi",
      show_more: "Ko'proq o'qituvchilarni ko'rsatish",
      show_all: "Maktabdagi barcha o'qituvchilarni ko'rsatish",
      selected: "({count}) tanlangan",
      closeDrawer: "Rejalashtirishni davom ettirish",
      search: "O'qituvchi yoki jamoa qidirish",
      not_available: "Bu o'qituvchining {date} da bo'sh vaqti yo'q."
    },
    DrawerAgenda: {
      no_meetings_title: "Sizda rejalashtirilgan uchrashuvlar yo'q.",
      no_meetings_message: "O'qituvchi va vaqtni tanlaganingizda, uchrashuv shu yerda ko'rinadi.",
      new_meeting_label: "Yangi",
      cancel_button: "Bekor qilish",
      student_label: "O'quvchi",
      meeting_type_location: "Uchrashuv turi/manzil",
      comment_label: "Izoh",
      save_comment_button: "Izohni saqlash",
      confirm_label: "Tasdiqlang:",
      confirm_cancel_button: "Ha, uchrashuvni bekor qilish ",
      do_not_cancel_button: "Bekor qilmaslik",
      confirm_agenda_button: "Kun tartibini tasdiqlash",
      confirm_agenda_message_line1: "Har doim qaytib o'zgartirishingiz mumkin.",
      confirm_agenda_message_line2: "Joriy kun tartibingiz sizga elektron pochta orqali yuboriladi."
    },
    EmailConsent: {
      message:
        "Maxfiylik va xavfsizligingizni himoya qilish uchun tizimdan elektron pochta orqali xabarnomalar olishga rozilik berishingiz kerak.",
      consent: "Roziman"
    },
    UserManagement: {
      pageTitle: "User Management",
      pageSubtitle:
        "Add and manage school and district staff accounts. Staff sign in with school or district login using this site's account.",
      addUser: "Add user",
      editUser: "Edit user",
      loading: "Loading users…",
      emptyTitle: "No staff users yet",
      emptyMessage: "Use Add user to create a school or district staff account.",
      tableUsername: "Username",
      tableEmail: "Email",
      tableRole: "Role",
      tableActions: "Actions",
      typeSchool: "School",
      typeDistrict: "District",
      roleTeam: "Team",
      roleSchool: "School Admin",
      roleReporter: "School Reporter",
      roleDistrict: "District Admin",
      roleNoIntegration: "School Admin without Integration",
      roleNotSet: "Role not set",
      roleUnknown: "Role ({id})",
      formUsername: "Username",
      formEmail: "Email",
      formPassword: "Password",
      formNewPassword: "New password (optional)",
      formRole: "Role",
      loginHint:
        "Staff sign in with the school portal. District staff may use the district portal subdomain when applicable.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDeleteTitle: "Remove this user?",
      confirmDeleteBody:
        "This will remove the staff account from your school. This action cannot be undone.",
      validationRequired: "Please fill in all required fields.",
      createdSuccess: "User created.",
      updatedSuccess: "User updated.",
      deletedSuccess: "User removed.",
      genericError: "Something went wrong. Please try again.",
      changeRoleTitle: "Change role",
      roleUpdatedSuccess: "Role updated.",
      deleteUserAria: "Remove user",
      formSchool: "School",
      validationSchoolRequired: "Please select a school.",
      schoolListEmpty: "No schools are available in this district."
    },
    StudentsDirectory: {
      saveLinkHousehold: "Save link household",
      saveLinkHouseholdNothing: "No changes to save.",
      saveLinkHouseholdSuccess: "Link household updated for {count} students.",
      saveLinkHouseholdError: "Could not update link household.",
      saveLinkHouseholdPartial: "Updated {saved} students; {failed} could not be saved."
    },
    Events: {
      loadError: "Tadbirlarni yuklab bo‘lmadi.",
      retry: "Qayta urinish"
    }
  }
};
